import React from "react";

import schoolImg from "../assets/images/school-img.jpeg";

import classes from "./VideoSide.module.css";

const VideoSide = () => {
  return (
    <div className={classes["wrapper"]}>
      <img className={classes["img"]} src={schoolImg} alt="" />
    </div>
  );
};

export default VideoSide;
